import { EFeatureFlags } from 'constants/features';
import { IModalOptions } from 'modules/modals/types';
import AddTDPDialog from 'pages/tdp/modals/addTdp';
import { NewThreadButton } from './NewThreadButton';

interface IHeaderButtonProps {
  open: (options: IModalOptions) => void;
  features: Record<EFeatureFlags, boolean>;
}

export const HeaderButton = ({ open, features }: IHeaderButtonProps) => {
  return (
    <div className="flex w-full flex-row items-center justify-between gap-2 lg:w-auto">
      <NewThreadButton open={open} />
      {features['boeing-tdp'] && <AddTDPDialog />}
    </div>
  );
};
